import inviteCodes from 'src/screens/invite-codes';
export default inviteCodes;
